<app-card-content [border]="false" [headerColor]="true" icon="pi pi-star-fill" title="Especialidade" subtitle="Dados da especialidade médica">
    <div card-header class="flex items-center gap-2">
        @if (!modoCriacao()) {
            <p-button icon="pi pi-arrow-left" [text]="true" [rounded]="true" size="small" (onClick)="voltar.emit()" pTooltip="Voltar" tooltipPosition="left" />
            <app-botao-acoes [label]="'Ações'" [items]="acoesFormulario" [destaque]="itensEdicao" [destaqueAtivo]="modoEdicao()" [appCan]="roleEspecialidadeEditar" [appCanUf]="pessoa()?.uf" [permissaoUf]="pessoa()?.uf ?? null" />
        }
    </div>

    @if (especialidadeCarregando) {
        <div class="mb-3 text-sm text-gray-600">Carregando dados de especialidade...</div>
    }
    @if (especialidadeErro) {
        <div class="mb-3 text-sm text-red-600">{{ especialidadeErro }}</div>
    }

    <form [formGroup]="especialidadeForm">
        <div class="flex flex-col gap-4">
            <!-- Informações da Especialidade -->
            <app-card-content [headerColor]="false" icon="pi pi-info-circle" title="Informações da Especialidade">
                <div class="grid grid-cols-1 lg:grid-cols-2 gap-4 mb-6">
                    <div class="field">
                        <label for="especialidade" class="font-semibold block mb-2">Especialidade</label>
                        @if (modoEdicao()) {
                            <p-select
                                id="especialidade"
                                formControlName="especialidade"
                                [options]="especialidadeOptions"
                                placeholder="Selecione a especialidade"
                                [filter]="true"
                                filterPlaceholder="Buscar..."
                                [styleClass]="'w-full'"
                                [loading]="especialidadeSelectCarregando"
                                appendTo="body"
                            />
                        } @else {
                            <input pInputText id="especialidade" [value]="selectedDetail()?.dsEspecialidade ?? ''" placeholder="Especialidade" class="w-full readonly-input" [readonly]="true" />
                        }
                        @if (campoInvalido('especialidade')) {
                            <small class="erro-campo">{{ mensagemErroCampo('especialidade') }}</small>
                        }
                    </div>
                    <div class="field">
                        <label for="divulgar" class="font-semibold block mb-2">Divulgar?</label>
                        <app-switch-sim-nao inputId="divulgar" formControlName="divulgar" [desabilitado]="!modoEdicao()" />
                    </div>
                </div>
                <div class="grid grid-cols-1 lg:grid-cols-2 gap-4">
                    <div class="field">
                        <label for="areaAtuacao" class="font-semibold block mb-2">Área de Atuação</label>
                        @if (modoEdicao()) {
                            <p-select
                                id="areaAtuacao"
                                formControlName="areaAtuacao"
                                [options]="areaAtuacaoOptions"
                                placeholder="Selecione a área de atuação"
                                [filter]="true"
                                filterPlaceholder="Buscar..."
                                [styleClass]="'w-full'"
                                [loading]="areaAtuacaoSelectCarregando"
                                [disabled]="!especialidadeForm.get('especialidade')?.value"
                                appendTo="body"
                            />
                        } @else {
                            <input pInputText id="areaAtuacao" [value]="selectedDetail()?.dsAreaAtuacao ?? ''" placeholder="Área de atuação" class="w-full readonly-input" [readonly]="true" />
                        }
                    </div>
                    <div class="field">
                        <label for="resolucao" class="font-semibold block mb-2">Resolução</label>
                        <input pInputText id="resolucao" formControlName="resolucao" placeholder="Resolução" [class]="!modoEdicao() ? 'w-full readonly-input' : 'w-full'" [readonly]="!modoEdicao()" />
                    </div>
                </div>
            </app-card-content>

            <!-- Informações do Certificado -->
            <app-card-content [headerColor]="false" icon="pi pi-file" title="Informações do Certificado">
                <div class="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                    <div class="field">
                        <label for="dtCertificado" class="font-semibold block mb-2">Dt. Certificado</label>
                        <p-inputmask id="dtCertificado" formControlName="dtCertificado" mask="99/99/9999" placeholder="DD/MM/AAAA" [styleClass]="!modoEdicao() ? 'w-full readonly-input' : 'w-full'" [readonly]="!modoEdicao()" />
                        @if (campoInvalido('dtCertificado')) {
                            <small class="erro-campo">{{ mensagemErroCampo('dtCertificado') }}</small>
                        }
                    </div>
                    <div class="field">
                        <label class="font-semibold block mb-2">UF do Curso</label>
                        <app-estado-select [(uf)]="ufCurso" [disabled]="!modoEdicao()" (ufChange)="especialidadeForm.patchValue({ ufCurso: ufCurso })" />
                    </div>
                </div>
                <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
                    <div class="field">
                        <label for="numeroLivro" class="font-semibold block mb-2">Número do Livro</label>
                        <input pInputText id="numeroLivro" formControlName="numeroLivro" [class]="!modoEdicao() ? 'w-full readonly-input' : 'w-full'" [readonly]="!modoEdicao()" />
                    </div>
                    <div class="field">
                        <label for="numeroFolha" class="font-semibold block mb-2">Número da Folha</label>
                        <input pInputText id="numeroFolha" formControlName="numeroFolha" [class]="!modoEdicao() ? 'w-full readonly-input' : 'w-full'" [readonly]="!modoEdicao()" />
                    </div>
                    <div class="field">
                        <label for="dataRegistro" class="font-semibold block mb-2">Data de Registro</label>
                        <p-inputmask id="dataRegistro" formControlName="dataRegistro" mask="99/99/9999" placeholder="DD/MM/AAAA" [styleClass]="!modoEdicao() ? 'w-full readonly-input' : 'w-full'" [readonly]="!modoEdicao()" />
                        @if (campoInvalido('dataRegistro')) {
                            <small class="erro-campo">{{ mensagemErroCampo('dataRegistro') }}</small>
                        }
                    </div>
                    <div class="field">
                        <label for="cancelamento" class="font-semibold block mb-2">Cancelamento</label>
                        <input pInputText id="cancelamento" formControlName="cancelamento" [class]="!modoEdicao() ? 'w-full readonly-input' : 'w-full'" [readonly]="!modoEdicao()" />
                    </div>
                </div>
            </app-card-content>

            <!-- Comissão de Aprovação -->
            <app-card-content [headerColor]="false" icon="pi pi-check-circle" title="Comissão de Aprovação">
                <div class="grid grid-cols-1 lg:grid-cols-3 gap-4 mb-4">
                    <div class="field">
                        <label for="aprovadoPor" class="font-semibold block mb-2">Aprovado por</label>
                        <p-select id="aprovadoPor" formControlName="aprovadoPor" [options]="aprovadoPorOptions" placeholder="Selecione" [styleClass]="!modoEdicao() ? 'w-full readonly-input' : 'w-full'" [readonly]="!modoEdicao()" appendTo="body" />
                    </div>
                    <div class="field">
                        <label for="aprovadoEm" class="font-semibold block mb-2">Aprovado em</label>
                        <p-inputmask id="aprovadoEm" formControlName="aprovadoEm" mask="99/99/9999" placeholder="DD/MM/AAAA" [styleClass]="!modoEdicao() ? 'w-full readonly-input' : 'w-full'" [readonly]="!modoEdicao()" />
                        @if (campoInvalido('aprovadoEm')) {
                            <small class="erro-campo">{{ mensagemErroCampo('aprovadoEm') }}</small>
                        }
                    </div>
                    <div class="field">
                        <label for="tipoRegistro" class="font-semibold block mb-2">Tipo do Registro</label>
                        <p-select id="tipoRegistro" formControlName="tipoRegistro" [options]="tipoRegistroOptions" placeholder="Selecione" [styleClass]="!modoEdicao() ? 'w-full readonly-input' : 'w-full'" [readonly]="!modoEdicao()" appendTo="body" />
                    </div>
                </div>
                <div class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-4">
                    <div class="field">
                        <label for="numeroAprovacao" class="font-semibold block mb-2">Número da Aprovação</label>
                        <input pInputText id="numeroAprovacao" formControlName="numeroAprovacao" [class]="!modoEdicao() ? 'w-full readonly-input' : 'w-full'" [readonly]="!modoEdicao()" />
                    </div>
                    <div class="field">
                        <label for="numeroRequerimento" class="font-semibold block mb-2">Número Requerimento</label>
                        <input pInputText id="numeroRequerimento" formControlName="numeroRequerimento" [class]="!modoEdicao() ? 'w-full readonly-input' : 'w-full'" [readonly]="!modoEdicao()" />
                    </div>
                    <div class="field">
                        <label for="numeroRegistro" class="font-semibold block mb-2">Número de Registro</label>
                        <input pInputText id="numeroRegistro" formControlName="numeroRegistro" [class]="!modoEdicao() ? 'w-full readonly-input' : 'w-full'" [readonly]="!modoEdicao()" />
                    </div>
                    <div class="field">
                        <label for="perito" class="font-semibold block mb-2">Perito?</label>
                        <app-switch-sim-nao inputId="perito" formControlName="perito" [desabilitado]="!modoEdicao()" />
                    </div>
                </div>
            </app-card-content>

            <!-- Documento -->
            <app-card-content [headerColor]="false" icon="pi pi-file-edit" title="Documento">
                <div class="grid grid-cols-1 gap-4 mb-4">
                    <div class="field">
                        <label for="tipoDocumento" class="font-semibold block mb-2">Tipo de Documento</label>
                        <p-select
                            id="tipoDocumento"
                            formControlName="tipoDocumento"
                            [options]="tipoDocumentoOptions"
                            placeholder="Selecione"
                            [styleClass]="!modoEdicao() ? 'w-full readonly-input' : 'w-full'"
                            [readonly]="!modoEdicao()"
                            [loading]="tipoDocumentoCarregando"
                            appendTo="body"
                        />
                    </div>
                </div>
                <div class="grid grid-cols-1 lg:grid-cols-2 gap-4">
                    <div class="field">
                        <label for="sobreDocumento" class="font-semibold block mb-2">Sobre o Documento</label>
                        <textarea pTextarea id="sobreDocumento" formControlName="sobreDocumento" rows="4" [class]="!modoEdicao() ? 'w-full readonly-input' : 'w-full'" [readonly]="!modoEdicao()"></textarea>
                    </div>
                    <div class="field">
                        <label for="observacoes" class="font-semibold block mb-2">Observações</label>
                        <textarea pTextarea id="observacoes" formControlName="observacoes" rows="4" [class]="!modoEdicao() ? 'w-full readonly-input' : 'w-full'" [readonly]="!modoEdicao()"></textarea>
                    </div>
                </div>
            </app-card-content>

            @if (modoCriacao()) {
                <div class="flex justify-end gap-2">
                    <p-button label="Cancelar" icon="pi pi-times" [text]="true" (onClick)="cancelar()" />
                    <p-button label="Salvar" icon="pi pi-check" (onClick)="salvar()" [appCan]="roleEspecialidadeCriar" [appCanUf]="pessoa()?.uf" />
                </div>
            }
        </div>
    </form>
</app-card-content>
